 import "@fontsource/poppins";
import "@fontsource/poppins/300.css";
import "@fontsource/poppins/500.css";
import "@fontsource/poppins/700.css";

import ReactDOM from "react-dom/client";
import "./Styles/ColorsFonts/colors.css";
import "./Styles/ColorsFonts/fonts.css";
import "./Styles/SizesBg/style.css";
import "./index.css";
import "./Styles/Mobile/pwa.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.js";
import "react-datepicker/dist/react-datepicker.css";
import "react-dropzone";
import "leaflet/dist/leaflet.css";
import "leaflet-draw/dist/leaflet.draw.css";
import "leaflet-control-geocoder/dist/Control.Geocoder.css";
import "react-checkbox-tree/lib/react-checkbox-tree.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "react-toastify/dist/ReactToastify.css";
import "antd/dist/reset.css";
import "react-phone-input-2/lib/style.css";
import { persistor, store } from "./Redux/Store";
import { Provider } from "react-redux";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <Provider store={store}>
        <App />
    </Provider>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals

if (process.env.NODE_ENV === "production" && "serviceWorker" in navigator) {
    window.addEventListener("load", () => {
        const swUrl =` ${process.env.PUBLIC_URL}/sw.js`;

        navigator.serviceWorker
            .register(swUrl)
            .then((registration) => {
                console.log("SW registered. Scope:", registration.scope);
                // Important: Check for updates every time the page is opened
                registration.update();
            })
            .catch((error) => {
                console.error("SW registration failed:", error);
            });
    });
}

// AUTOMATIC REFRESH LOGIC
let refreshing = false;
navigator.serviceWorker.addEventListener("controllerchange", () => {
    // This fires when the new service worker takes over (skipWaiting + clients.claim)
    if (refreshing) return;
    refreshing = true;
    console.log("New Service Worker taking control. Reloading...");
    window.location.reload();
});

reportWebVitals();